import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  Input,
  Label,
  Modal,
  Row,
  Tooltip
} from 'reactstrap';
import MyTerminal from './TtyShell';
import { bandModelWindowsOption } from '../utils/constants';
import { useSelector, useDispatch } from 'react-redux';
import SpinnerCircles from './Spinner/SpinerCircles';
import {  
  downloadTtyProfile, 
  postTtyData, 
  manageOpenVpnProfile,
  orderNewBTNs,
  fetchAvailableOobBTNs,
  fetchTtyData,
  fetchAndAssignUsbs
} from '../actions/EpikBoxes';
import edit from "../Res/Icon/edit.png"
import del from '../Res/Icon/delete.png';
import disconnectDID from '../Res/Icon/disconnect-number.svg';
import Toggle from './Toggle';
import { toast } from 'react-toastify';
import CustomWarning from './CustomWarning';
import { getPermissionForComponent } from '../utils/permissionsUtils';
import { useUnifiedFetch, useUnifiedMutate } from '../hooks'
import TagsInput from './Tags';
import OobmEditMode from './OobmEditMode';
import RefreshLogo from '../Res/Icon/Fetch-Results.svg'
import TooltipIcon from '../../src/components/EpikBoxes/EpikBoxDetails/TooltipIcon/TooltipIcon';
import InfoPopup from './InfoPopup';

const headLabel = 'Out of Band Management';
const twoFaMethodOptions = [
  { label: 'Authenticator App', value: '2factorapp' },
  { label: 'SMS', value: 'sms' },
  { label: 'Email', value: 'email' }
]

const CustomInput = ({ name, onChangeInput = () => ({}), value, label, input, item, state = {}, radioInput = true, ...props }) => (
  <div className='d-flex align-items-center mb-2' style={{ color: '#495057a6' }}>
    {radioInput && (<Input
      name={name}
      type="radio"
      onChange={e => {
        onChangeInput(e.target.name, value);
      }}
      checked={name === 'authPlatform' ? state.authPlatform === value : null}
      {...props}
    />)}
    {input ? (
      <Input
        name={item.id} type="text" defaultValue={item.label}
        onChange={e => {
          const updatedVal = {
            ...state.updatedUsbs,
            [e.target.name]: {
              ...state.updatedUsbs[item.id], customTitle: e.target.value
            }
          }
          onChangeInput('updatedUsbs', updatedVal);
        }}
      />
    ) :
      <span className='usb-simple-title'> {label}</span>
    }
  </div>
);

const GetTwoFaModal = ({ state, onChangeInput, options, oobmTtyData, onGoHandler, savedProfiles, user, refreshSavedProfiles ,userDataBand}) => {

  const token = localStorage.getItem('jwtToken') || null;
  const box = useSelector(state => state.AppState.boxDetails.box);
  const oobmTtyResponse = useSelector(state => state.AppState.boxDetails.oobmTtyData);
  const oobOrderedBtns = useSelector(state => state.AppState.boxDetails.oobOrderedBtns);
  const assignedUsbs = useSelector(state => state.AppState.boxDetails.oobList.assignedUsbs);
  const dispatch = useDispatch()

  const [showDetails, setShowDetails] = useState(false);
  const [confirmWhitelist, setConfirmWhitelist] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingFor, setLoadingFor] = useState('');
  const [ttyDetails, setTtyDetails] = useState({
    ttyAccess: false,
    ttyOverVPN: false,
    ipAddressess: []
  });
  const [ipAddress, setIpAddress] = useState([]);
  const [oobmSavedProfiles, setOobmSavedProfiles] = useState({});
  const [oobmDbProfiles, setOobmDbProfiles] = useState(null);
  const [showOobmModal, setShowOobmModal] = useState(false);
  const [deleteProfile, setDeleteProfile] = useState(null);
  const [deleteType, setDeleteType] = useState('del');
  const [oobAvailableBtns, setOobAvailableBtns] = useState([]);
  const ttyOptionsAccess = getPermissionForComponent('ttyOptionsAccess',user.permissionsGroup)
  const outBandManagement = getPermissionForComponent('outBandManagement',user.permissionsGroup)


  const {
    data: oobmPortProfiles,
    fetchData: fetchingOobmProfiles
  } = useUnifiedFetch(`oob/${box?._id}/fetchSavedProfiles`, false);

  const { mutate: deleteOobmProfile, isLoading, error } = useUnifiedMutate();
  const { mutate: activateOobPortOnBox, isPortLoading, activeError } = useUnifiedMutate();

  useEffect(() => {
    setTtyDetails({ ...ttyDetails, ipAddressess: ipAddress })
  }, [ipAddress]);

  useEffect(() => {
    setOobmSavedProfiles(savedProfiles);
  }, [savedProfiles]);
  
  useEffect(() => {
    setOobAvailableBtns(oobOrderedBtns);
  }, [oobOrderedBtns]);

  useEffect(() => {
    if (oobmTtyResponse) {
      setTtyDetails({
        ttyOverVPN: oobmTtyResponse?.ttyVpn,
        ipAddressess: oobmTtyResponse?.allowedIps,
      })
    }
  }, [oobmTtyResponse])

  useEffect(() => {
    oobmTtyData(ttyDetails)
  }, [ttyDetails])

  const onChangettyDetails = (key, value) => {
    setTtyDetails(pre => ({
      ...pre,
      [key]: value
    }))
  }

  const onDownloadProfile = async () => {
    setLoadingFor('download');
    setLoading(true);
    await dispatch(downloadTtyProfile(token, box._id));
    setLoading(false);
    setLoadingFor('');
  }

  const seperateIpAddresses = (ipAddresses) => {
    const ipArray2 = ipAddresses?.map(item => {
      if (item.includes('-')) {
        const ipRange = item.split('-')
        // check the last octet of first ip and last octet of second ip and generate the range
        const firstIp = ipRange[0].split('.')
        const secondIp = ipRange[1].split('.')
        const firstIpLastOctet = Number(firstIp[3]);
        const secondIpLastOctet = Number(secondIp[3]);
        const ipRangeArray = []
        for (let i = firstIpLastOctet; i <= secondIpLastOctet; i++) {
          ipRangeArray.push(`${firstIp[0]}.${firstIp[1]}.${firstIp[2]}.${i}`)
        }
        return ipRangeArray
      } else {
        return item
      }
    })
    return ipArray2.flat()
  }

  const ipToNumber = (ip) => {
    return ip.split('.').reduce((acc, octet) => (acc << 8) + parseInt(octet, 10), 0);
  }

  const isIpInRange = (ip, range) => {
      const [startIp, endIp] = range.split('-');
      const ipNum = ipToNumber(ip);
      const startIpNum = ipToNumber(startIp);
      const endIpNum = ipToNumber(endIp);
      return ipNum >= startIpNum && ipNum <= endIpNum;
  }

  const removeDuplicates = (arr) => {
    return (arr || []).filter((ip, index) => {
      if (String(ip).includes('-')) return true; // keep ranges
          // Check if this IP falls within any of the ranges in the array
      return !(arr || []).some((range, i) => i !== index && String(range).includes('-') && isIpInRange(ip, range));
    });
  };

  const doSaveTtyWhitelist = async () => {
    const ipAddresses = seperateIpAddresses(ttyDetails?.ipAddressess);

      setLoadingFor('ttyoptions');
      setLoading(true);

      const payload = {
        ttyVpn: ttyDetails?.ttyOverVPN,
        allowedIps: ipAddresses?.length ? ipAddresses : ["0.0.0.0"],
        whitelistIps: removeDuplicates(ttyDetails?.ipAddressess)
      }

      console.log(JSON.stringify(payload, 0, 2));
    const result = await dispatch(postTtyData(token, box._id, payload));

    if (result) onChangettyDetails('ttyDetails', { ...ttyDetails });
    setLoading(false);
    setLoadingFor('');
  };
  const isValidIpv4 = (ip) => {
    if (typeof ip !== 'string') return false;
    const s = ip.trim();
    const parts = s.split('.');
    if (parts.length !== 4) return false;
    return parts.every(p => /^\d+$/.test(p) && Number(p) >= 0 && Number(p) <= 255);
  };
  const isValidCidr = (cidr) => {
    if (typeof cidr !== 'string') return false;
    const s = cidr.trim();
    const [ip, prefix] = s.split('/');
    if (!ip || prefix === undefined) return false;
    if (!isValidIpv4(ip)) return false;
    if (!/^\d+$/.test(prefix)) return false;
    const p = Number(prefix);
    return p >= 0 && p <= 32;
  };
  const isValidRange = (range) => {
    if (typeof range !== 'string') return false;
    const s = range.trim();
    const parts = s.split('-').map(x => x.trim());
    if (parts.length !== 2) return false;
    const [start, end] = parts;
    if (!isValidIpv4(start) || !isValidIpv4(end)) return false;
    return ipToNumber(start) <= ipToNumber(end);
  };
  const validateWhitelistList = (list) => {
    const entries = (list || []).map(x => String(x).trim()).filter(Boolean);

    if (!entries.length) {
      return { ok: false, message: 'Please add at least one IP/CIDR/range before saving.' };
    }
    for (const e of entries) {
      const ok = e.includes('/') ? isValidCidr(e) : e.includes('-') ? isValidRange(e) : isValidIpv4(e);
      if (!ok) return { ok: false, message: `Invalid entry: ${e}` };
    }
    return { ok: true };
  };
  const onTtyOverVpnToggle = async (action = 'disableandsave') => {
    if (action === 'disableandsave') {
      const v = validateWhitelistList(ttyDetails?.ipAddressess);
      if (!v.ok) {
        toast.error(v.message);
        return;
      }
      setPendingAction('saveWhitelist');
      setConfirmWhitelist(true);
      return;
    }
 if (action === 'enable') {
      setLoadingFor('vpntoggle');
      setLoading(true);
  
      const respone = await dispatch(manageOpenVpnProfile(token, box._id, !ttyDetails.ttyOverVPN));
  
      console.log(respone);
  
      if (respone) {
        onChangettyDetails('ttyOverVPN', !ttyDetails.ttyOverVPN);
        onChangettyDetails('ipAddressess', []);
      }
  
    }
    setLoading(false);
    setLoadingFor('');
  }

  const handleEditActionClick = async (item) => {
    setLoading(true);
    setLoadingFor(`edit_${item?.number}`);
  
    const resp = await fetchingOobmProfiles();
  
    if (!resp?.status && resp?.message) {
      toast.error(resp?.message);
      onChangeInput('editOption', false);
    } else {
      setOobmSavedProfiles(resp);
      setShowOobmModal(true);
      setOobmDbProfiles(item);
    }
  
    setLoading(false);
    setLoadingFor('');
  };
  
  const refreshInfo = async() => {
    await dispatch(fetchTtyData(token, box?._id));
    await dispatch(fetchAndAssignUsbs(token, box?._id));
    const resp = await fetchingOobmProfiles();
    if (resp) setOobmSavedProfiles(resp);
    const availableBtns = await dispatch(fetchAvailableOobBTNs(token, box?._id));
    if (availableBtns) {
      setOobAvailableBtns(availableBtns);
    }
  }

  const refreshOobmInfo = async() => {
    setLoading(true);
    setLoadingFor("refreshoobm");

    await refreshInfo()

    setLoading(false);
    setLoadingFor("");
  }

  const handleDeletedActionClick = async () => {
    const deleteItem = deleteProfile;
    setLoading(true);
    setLoadingFor(`${deleteType}_${deleteItem?.number}`);

    setDeleteProfile(null);

    if(isLoading){
      return;
    }

    const endpoint = `oob/${box?._id}/delete-profile`;
    const method = 'PUT';
    const payload = {
      boxId: box?._id,
      isBoxTab: true,
      did: deleteItem?.number,
      usbPort: deleteItem?.usbPort?.title,
      deleteType: deleteType === 'del' ? 'delete' : 'disconnect'
    }

    const resp = await deleteOobmProfile({
      isMyEpik: false,
      endpoint,
      method,
      body: payload,
    });

    if (resp) {
      refreshInfo();
    } else {
      toast.error(error);
    }
    
    setLoading(false);
    setLoadingFor(``);
  };

  useEffect(() => {
    const fetchData = async () => {
      const resp = await fetchingOobmProfiles();
      if (resp) setOobmSavedProfiles(resp);
    };
  
    fetchData();
  }, [refreshSavedProfiles, box?._id]);  

  const isTtyEnabled =
    Object.values(oobmSavedProfiles)?.length > 0 ?
      Object.values(oobmSavedProfiles)?.some(oob => oob?.ttyStatus === 'true' && !oob?.disconnected) : 
    options?.some(port => port?.allowTTY && !port?.disconnected);

  const onActivateButton = async () => {
    // Filter out assigned USBs that are not in disconnected USBs
    const activeUsbs = assignedUsbs?.filter(assignedUsb => !assignedUsb?.disconnected);
 
    if (!activeUsbs?.length && Object.values(oobmSavedProfiles)?.length === 0) {
      toast.error('No OOBM ports available to activate.');
      return;
    }

    setLoading(true);
    setLoadingFor('activate');

    if(isPortLoading){
      return;
    }

    const endpoint = `boxes/${box?._id}`;
    const method = 'PUT';
    const payload = {
      ...box,
      boxId: box?._id,
      isBoxTab: true,
      oobPortActivated: true,
      oobPortActivatedDate: new Date(),
    }

    const resp = await activateOobPortOnBox({
      isMyEpik: false,
      endpoint,
      method,
      body: payload,
    });

    if (resp) {
      toast.success('OOBM Port Activated Successfully');
      setTimeout(() => {
        window.location.reload();
      }, 700);
    } else {
      toast.error(activeError);
    }

    setLoading(false);
    setLoadingFor('');
  }

  return (
    <>
      <div className={`d-flex justify-content-between align-item-center oobm-header`}>
        <label className='modal-clr-heading'>{headLabel}</label>
        <div className='d-flex align-item-center'>
          {loading && loadingFor === 'activate' ? (
            <div className='d-flex align-items-center mb-2 mt-1 mr-3' style={{ margin: '5px', height: '28px' }}><SpinnerCircles red /></div>
          ) : (
            <Button
              color={!box?.oobPortActivated ? 'primary' : 'success'}
              style={{ marginRight: '10px' }}
              onClick={onActivateButton}
              disabled={box?.oobPortActivated || !(outBandManagement === 'write' || outBandManagement === 'both')}
              className='d-flex align-items-center mb-2 mt-1 mr-3'
            >
              {!box?.oobPortActivated ? 'Activate Port' : 'Activated'}
            </Button>
          )}
          {loading && loadingFor === 'refreshoobm' ? (
            <div className='d-flex align-items-center mb-2 mt-1 mr-3' style={{ margin: '5px', height: '28px' }}><SpinnerCircles red /></div>
          ) : (
            <div className={'mt-1 mr-3'} onClick={() => refreshOobmInfo()} style={{ cursor: 'pointer' }}>
              <TooltipIcon
                tipId="oobm-icon"
                imgSrc={RefreshLogo}
                displayData="Refresh OOBM Info"
                placement="top"
                customStyle={{ width: '22px' }}
              />
            </div>
          )}
          {oobAvailableBtns?.length > 0 && (
            <div className=''>
              <Label>View Details</Label>
              <input
                className='mt-2 ml-2 cursor-pointer'
                type="checkbox"
                checked={showDetails}
                onChange={(e) => setShowDetails(!showDetails)}
                id="view_assigned_DIDs"
              />
            </div>
          )}
        </div>
      </div>
      <div className={`band-management-container`}>
        <div className={`management-container-1 ${showDetails && !state.editOption ? 'show-port-details' : ''}`}>
          <table className=" border-none width-auto">
            {oobAvailableBtns?.length > 0 && (
              <tr className='header-row'>
                <td className='pl-5 col-sticky col-title'>BTN</td>
                <td className='pl-5'>Category</td>
                <td className='pl-5'>Interface</td>
                <td className='pl-5'>Interface State</td>
                <td className='pl-5'>TTY</td>
                {showDetails && !state.editOption && (
                  <>
                    <td className='pl-5'>Speed</td>
                    <td className='pl-5'>Data Bits</td>
                    <td className='pl-5'>Stop Bits</td>
                    <td className='pl-5'>Parity</td>
                    <td className='pl-5'>Flow Control</td>
                  </>
                )}
                {(outBandManagement === 'write' || outBandManagement === 'both') && 
                <td className='ml-3 pl-5 pr-3 col-sticky col-actions'>Actions</td>
                }
                
              </tr>
            )}
            <tr><td></td></tr>
            <tr><td></td></tr>
            {oobAvailableBtns?.length > 0 && oobAvailableBtns?.map((item, idx) => {
              const nationalFormatedNumber = item?.number?.replace(/^\+1/, '');
              const currentProfile = Object.keys(oobmSavedProfiles)?.length && oobmSavedProfiles[nationalFormatedNumber] || null;
              const status = !currentProfile ? item?.allowTTY : currentProfile?.ttyStatus === 'true';

              const ttyStatus = status ? 'Yes' : 'No';
              const usbSpeed = currentProfile && currentProfile?.Speed || item?.usbSpeed || '-';
              const dataBits = currentProfile && currentProfile?.dbits || item?.dataBits || '-';
              const stopBits = currentProfile && currentProfile?.sbits || item?.stopBits || '-';
              const parity = currentProfile && currentProfile?.parity || item?.parity || '-';
              const flowControl = currentProfile && currentProfile?.flowC || item?.flowControl || '-';

              return (
                <tr key={item?.number}>
                  <td className='pr-5 col-sticky col-title'>
                    <CustomInput
                      name="usb"
                      value={item?.usbPort?.portNo}
                      label={item?.number}
                      onChangeInput={(name, value) => onChangeInput(name, value)}
                      item={item}
                      state={state}
                      disabled={!item?.usbPort || item?.usbPort?.disconnected}
                    />
                  </td>
                  <td className='pl-5 pr-5'>
                    <div className='d-flex align-items-center mb-2' style={{ color: '#495057a6' }}>
                      <span class="usb-simple-title"> {item?.usbPort?.usbCategory?.title || 'Default'}</span>
                    </div>
                  </td>
                  <td className='pl-5 pr-5'>
                    <div className='d-flex align-items-center mb-2' style={{ color: '#495057a6' }}>
                      <span class="usb-simple-title"> {`${item?.usbPort?.title || '-'} ${item?.usbPort?.customTitle ? `( ${item?.usbPort?.customTitle} )` : ''}` || '-'} </span>
                    </div>
                  </td>
                  <td className='pl-5 pr-5'>
                    <div className='d-flex align-items-center mb-2' style={{ 
                      color: item?.usbPort?.disconnected
                        ? '#ff0000'
                        : item.number && item?.usbPort && item?.usbPort?.title
                        ? 'rgb(33 204 33)' 
                        : ''
                    }}>
                    <span className='usb-simple-title'>
                      { item?.usbPort?.disconnected
                        ? 'Disconnected'
                        : item.number && item?.usbPort && item?.usbPort?.title
                        ? 'Detected'
                        : '-'}
                    </span>
                    </div>
                  </td>
                  <td className='pl-5 pr-5'>
                    <div className='d-flex align-items-center mb-2' style={{ color: '#495057a6' }}>
                      <span class="usb-simple-title"> {ttyStatus}</span>
                    </div>
                  </td>
                  {showDetails && !state.editOption && (
                    <>
                    <td className='pl-5 pr-5'>
                      <div className='d-flex align-items-center mb-2' style={{ color: '#495057a6' }}>
                        <span class="usb-simple-title"> {usbSpeed}</span>
                      </div>
                    </td>
                    <td className='pl-5 pr-5'>
                      <div className='d-flex align-items-center mb-2' style={{ color: '#495057a6' }}>
                        <span class="usb-simple-title"> {dataBits}</span>
                      </div>
                    </td>
                    <td className='pl-5 pr-5'>
                      <div className='d-flex align-items-center mb-2' style={{ color: '#495057a6' }}>
                        <span class="usb-simple-title"> {stopBits}</span>
                      </div>
                    </td>
                    <td className='pl-5 pr-5'>
                      <div className='d-flex align-items-center mb-2' style={{ color: '#495057a6' }}>
                        <span class="usb-simple-title"> {parity}</span>
                      </div>
                    </td>
                    <td className='pl-5 pr-5'>
                      <div className='d-flex align-items-center mb-2' style={{ color: '#495057a6' }}>
                        <span class="usb-simple-title"> {flowControl}</span>
                      </div>
                    </td>
                    </>
                  )}
                  {(outBandManagement === 'write' || outBandManagement === 'both') && 
                  <td className='ml-3 pl-5 pr-3 col-sticky col-actions'>
                  <div className='d-flex align-items-center mb-2 mr-2' style={{ color: '#495057a6' }}>
                  {loading && loadingFor === `edit_${item?.number}` ? (
                    <div className='d-flex align-items-center mb-2 mr-2' style={{ margin: '5px', height: '28px' }}><SpinnerCircles red /></div>
                  ) : (
                    <img
                      onClick={() => {
                        handleEditActionClick(item);
                        onChangeInput('editOption', true);
                      }}
                      className="actions-icon"
                      src={edit}
                      alt="Edit BTN Profile"
                      title={'Edit BTN Profile'}
                    />
                  )}
                  {loading && loadingFor === `del_${item?.number}` ? (
                    <div className='d-flex align-items-center mb-2' style={{ margin: '5px', height: '28px' }}><SpinnerCircles red /></div>
                  ) : (
                    <img
                      onClick={() => {
                        setDeleteProfile(item);
                        setDeleteType('del');
                      }}
                      className={item?.usbPort && currentProfile ? 'actions-icon' : 'actions-icon disabled'}
                      src={del}
                      alt="Delete BTN Profile"
                      title={'Delete BTN Profile'}
                    />
                  )}
                  {loading && loadingFor === `disc_${item?.number}` ? (
                    <div className='d-flex align-items-center mb-2' style={{ margin: '5px', height: '28px' }}><SpinnerCircles red /></div>
                  ) : 
                          (
                            !currentProfile && (
                              <img
                                onClick={() => {
                                  setDeleteProfile(item);
                                  setDeleteType('disc');
                                }}
                                className={!currentProfile ? 'actions-icon disconnect' : 'actions-icon disconnect disabled'}
                                src={disconnectDID}
                                alt="Disconnect DID"
                                title={'Disconnect DID'}
                              />
                            )
                          )}
                  </div>
                </td>
                  }
                </tr>
            )})}
            {!oobAvailableBtns?.length && (
              <tr>
                <td colSpan={'6'} style={{ textAlign: 'center', padding: '30px' }}>
                  You haven't configured a billing telephone number yet. Please click 'Order BTN' to order one.
                </td>
              </tr>
            )}
          </table>
        </div>

        {oobAvailableBtns?.length > 0 && (
          <>
            <div className='management-container-2 auth-section'>
              <label className='ft-16 mt-3 mb-3'> 2FA Method </label>
              <div className='management-container-2a authentication'>
                <div className='2fa-section'>
                  {
                    twoFaMethodOptions.map((option, key) => {
                      const inputComponent = <CustomInput
                        name="authPlatform"
                        value={option.value}
                        label={option.label}
                        state={state}
                        onChangeInput={onChangeInput} />            
                      return (inputComponent)
                    })
                  }
                </div>
                <div className='cta-section'>
                  {((outBandManagement === 'write' || outBandManagement === 'both') && !userDataBand?.company?.oobmTerminalEmulator) && 
                  <Button color="primary" disabled={loading || state.loading || !state.usb} onClick={onGoHandler} className="ml-2">
                  {'Connect'}
                </Button>
                  }
                </div>
              </div>
            </div>
              {ttyOptionsAccess && (
                <div className='management-container-2'>
                <label className='ft-16 mt-3'> Options </label>
                <div className='management-container-2a'>
                  
                  {((ttyOptionsAccess === 'write' || ttyOptionsAccess === 'both' || ttyOptionsAccess === 'read')) && isTtyEnabled ? (
                  // {(ttyOptionsAccess || user?.companyHasOobBox) ? (
                      <Row>
                        <Col md='3'
                          className='d-flex align-items-center justify-content-between mb-4'>
                          <label className='mt-3 mb-3'> TTY Over VPN </label>
                          {loading && loadingFor === 'vpntoggle' ? (
                            <div ><SpinnerCircles red /></div>
                          ) : (
                            <Toggle
                              value={ttyDetails.ttyOverVPN}
                              onToggle={() => onTtyOverVpnToggle('enable')}
                              disabled={ttyDetails.disabled || ttyOptionsAccess === 'read'}
                            />
                          )}
                        </Col>
                        <Col md='8' className="mt-3 openvpn-profile">
                          {
                            ttyDetails.ttyOverVPN ? (
                              (ttyOptionsAccess === 'write' || ttyOptionsAccess === 'both') ? (
                              <>
                                <Button
                                  disabled={ttyDetails.disabled}
                                  color="primary" onClick={onDownloadProfile}>
                                  Download VPN Profile 
                                </Button>
                                {loading && loadingFor === 'download' && (
                                  <SpinnerCircles red />
                                )}
                                <a 
                                  style={{ marginLeft: '10px' }}
                                  href='https://openvpn.net/client/' 
                                  target='_blank' 
                                  className='btn btn-primary'>
                                  Download Software
                                </a>
                              </>
                              ) : (
                                <span className="text-muted">TTY Over VPN is enabled</span>
                              )
                            ) : (
                              <>
                                <div className='d-flex align-items-center justify-content-between'>
                                  <Label className={`mt-2`} id={`ipaddressoobm`}>Allowed IP Addresses:
                                    <sup>
                                      <InfoPopup 
                                        id="oobmoptions" 
                                        text={
                                          <div>
                                            <strong>Example:</strong><br />
                                            IPv4 address: 192.0.2.1<br />
                                          IPv4 address: 192.0.2.0/24<br />
                                            IPv4 range: 192.0.2.1-192.0.2.255
                                          </div>
                                        }
                                        placement={'bottom'}
                                        customClass={'oob-options'}
                                      />
                                    </sup>
                                  </Label>
                                  <TagsInput
                                    value={ttyDetails.ipAddressess}
                                    onChange={setIpAddress}
                                    inputName="ipRangeFrom"
                                    placeholderText={`${ !ttyDetails.ipAddressess?.length ? 'No IP Whitelisted!' : ''} Please enter IP Addresses e.g. 192.0.2.1, 192.0.2.0/24, 192.0.2.1-192.0.2.20`}
                                    customStyle={{ width: '100%', height: '3rem', border: 'none' }}
                                    helpText="Press 'Enter' or paste a list of comma-separated IPs"
                                    headText="TTY IP Whitelisting"
                                    showDelete={ttyOptionsAccess === 'read' ? false : true}
                                    disabled={ttyOptionsAccess === 'read'}
                                  />
                                </div>
                                <p className='note-text oobmaddressarea'>Multiple IP’s can be added using a comma to separate each entry. A range of IP addresses can be added by separating the start and end with a dash.</p>
                              </>
                            )
                          }
                        </Col>
                        {!ttyDetails.ttyOverVPN && (ttyOptionsAccess === 'write' || ttyOptionsAccess === 'both')&& (
                          <Col md='1' className={'mt-5'}>
                            {loading && loadingFor === 'ttyoptions' ? (
                              <SpinnerCircles red />
                            ) : (
                              <Button
                                disabled={loading || state.loading}
                                color="primary" onClick={() => onTtyOverVpnToggle('disableandsave')}>
                                Save 
                              </Button>
                            )}
                          </Col>
                        )}
                      </Row>
                  ) : (
                    <p className='text-center'>{!ttyOptionsAccess ? 'You don\'t have access to view options'
                      : 'Please enable TTY access to view options'}
                    </p>)
                  }
                </div>
              </div>
              )}
            
        </>
        )}
      </div>
      {/* ✅ Confirmation modal for validate */}
      {confirmWhitelist && (
        <CustomWarning
          isOpen={confirmWhitelist}
          onConfirm={async () => {
            setConfirmWhitelist(false);

            if (pendingAction === 'saveWhitelist') {
              await doSaveTtyWhitelist();
            }

            setPendingAction(null);
          }}
          onCancel={() => {
            setConfirmWhitelist(false);
            setPendingAction(null);
          }}
          customText="Yes"
          customCancelText="No"
        >
          <div>
            <p>You are about to whitelist the following IP addresses or ranges. Please validate this data before proceeding.</p>
            <div style={{ marginTop: '10px' }}>
              {(ttyDetails?.ipAddressess || []).map((ip, idx) => (
                <div key={idx} style={{ fontFamily: 'monospace' }}>{ip}</div>
              ))}
            </div>
          </div>
        </CustomWarning>
      )}

      {/* Show OobmEditMode Modal */}
      {showOobmModal && oobmDbProfiles && (
        <OobmEditMode
          isOpen={showOobmModal}
          onClose={() => {
            refreshInfo()
            setShowOobmModal(false)
            onChangeInput('editOption', false);
          }}
          apiResponse={oobmSavedProfiles || {}}  // Pass the response data to OobmEditMode
          dbResponse={oobmDbProfiles || {}}
          box={box}
          mode={'Edit'}
        />
      )}

      {deleteProfile && (
        <CustomWarning
        isOpen={deleteProfile}
        onConfirm={() => {
          handleDeletedActionClick()
        }}
        onCancel={() => setDeleteProfile(null)}
        customText={deleteType === 'del' ? 'Delete' : 'Disconnect'}
        customCancelText="No"
      >
        {`Are you sure you want to ${deleteType === 'del' ? 'delete BTN profile' : 'disconnect BTN'}?`}
      </CustomWarning>
      )}
    </>);
};

const TwoFaAuthInput = (state, onChangeInput) => (
  <>
    <label className='modal-clr-heading'>{headLabel}</label>
    <div className='management-2fa-container'>
      <div><label>Enter 2FA Code </label></div>
      <div>
        <Input
          type="text"
          value={state.otp}
          onChange={e => onChangeInput('otp', e.target.value)}
        />
      </div>
    </div>
  </>
);

const initialState = (default2fa = 'email') => ({
  usb: '',
  authPlatform: default2fa,
  otp: '',
  loading: false,
  twoFaId: null,
  editOption: false,
  updatedUsbs: {},
  categories: [],
  usbSpeed: '',
  usbCategory: '',
});
const BandManagementModal = ({
  isOpen,
  onCancel,
  loading,
  sendFA,
  OnAuthenticateFA,
  bandModelWindow,
  twoFaRes,
  oobSavedProfiles,
  userDataBand
}) => {
  const token = localStorage.getItem('jwtToken') || null;
  const box = useSelector(state => state.AppState.boxDetails.box);
  const oobList = useSelector(state => state.AppState.boxDetails.oobList);
  const user = useSelector(state => state.AppState.user);
  const oobOrderedBtns = useSelector(state => state.AppState.boxDetails.oobOrderedBtns);
  const [options, setOptions] = useState([
    // { label: 'Web SSH', value: 'webSSH' },
  ])
  const dispatch = useDispatch()
  const [state, setState] = useState(initialState());
  const [ttyDetails, setTtyDetails] = useState(null);
  const isTTY = bandModelWindow === bandModelWindowsOption.ttyShell;
  const [time, setTime] = useState(null)
  const [timeoutWarning, setTimeoutWarning] = useState(false)
  const [increaseTerminalLife, setIncreaseTerminalLife] = useState(false)
  const [orderBtn, setOrderBtn] = useState(false)
  const [orderedBtn, setOrderedBtn] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [savedProfiles, setSavedProfiles] = useState({})
  const [refreshSavedProfiles, setRefreshSavedProfiles] = useState(false)
  const outBandManagement = getPermissionForComponent('outBandManagement',user.permissionsGroup)
  const orderBtnOobm = getPermissionForComponent('orderBtnOobm', user.permissionsGroup);

  const {
    isLoading: isFetchingProfileSettings,
    data: userProfileSettings
  } = useUnifiedFetch(`users/profile-settings/${user?._id}`, true, true);

  useEffect(() => {
    if (!isFetchingProfileSettings && userProfileSettings?.default2fa){
      setState(state => ({ ...state, authPlatform: userProfileSettings?.default2fa }))
    }
  }, [userProfileSettings?.default2fa, isFetchingProfileSettings])

  useEffect(() => {
    if (twoFaRes && twoFaRes._id)
      setState(state => ({ ...state, twoFaId: twoFaRes._id }))
  }, [twoFaRes])

  useEffect(() => {
    const newOobList = [];
    (oobOrderedBtns || []).map(ob =>
      newOobList.push({
        label: ob?.usbPort?.customTitle,
        title: ob?.usbPort?.title,
        value: ob?.usbPort?.portNo,
        number: ob?.number,
        id: ob?.usbPort?._id,
        usbSpeed: ob?.usbPort?.usbSpeed || '9600',
        dataBits: ob?.usbPort?.dataBits || "8",
        flowControl: ob?.usbPort?.flowControl || "None",
        parity: ob?.usbPort?.parity || "None",
        stopBits: ob?.usbPort?.stopBits || "1",
        allowTTY: ob?.usbPort?.allowTTY,
        usbCategory: ob?.usbPort?.usbCategory,
        disconnected: ob?.usbPort?.disconnected,
      }),
    );

    setState(pre => ({
      ...pre,
      loading: false,
    }));
    setOptions(newOobList)
  }, [oobList, oobOrderedBtns]);

  useEffect(() => {
    if (bandModelWindow === bandModelWindowsOption.ttyShell) {
      setTime({ m: 4, s: 59 }) //start countdown for termianl connection
    }
  }, [bandModelWindow])

  useEffect(() => {
    setSavedProfiles(oobSavedProfiles)
  }, [oobSavedProfiles]);

  const onChangeInput = (key, value) => {
    let usbPort = {};
    if (key === 'usb') {
      const selectedPort = options?.find((usb) => usb?.value === value);
      usbPort = {
        number: selectedPort?.number,
        title: selectedPort?.title,
        label: selectedPort?.label
      }
    }

    setState(preState => ({
      ...preState,
      [key]: value,
      ...usbPort
    }));
  };

  const onGoHandler = async () => { 
    // send2FA
    const { usb, authPlatform, otp } = state;
    if (bandModelWindow === bandModelWindowsOption.faAuth) {
      // if (otp) OnAuthenticateFA({ ...state, authPlatform: '2factorapp' });
      if (otp) OnAuthenticateFA(state);
    } else if (bandModelWindow === bandModelWindowsOption.faInput) {
      if (usb && authPlatform) {
        sendFA(state);
      } else {
        toast.info(`Please select any USB Port.`)
        return;
      }
    }
  };

  const [forceClose, setForceClose] = useState(false)
  const ttyCloseHandler = () => {
    setForceClose(true)
  }

  const onCancelClick = () => {
    if (state.editOption && bandModelWindow === 'faInput') {
      onChangeInput('editOption', !state.editOption);
      return;
    }

    if (bandModelWindow === bandModelWindowsOption.ttyShell) {
      // setSessionEnd(true)
      // return
    }

    setState(initialState(userProfileSettings?.default2fa));
    setTime(null)
    setTimeoutWarning(false)
    setForceClose(false)
    onCancel();
  };

  const onChangettyDetails = (values) => {
    setTtyDetails(values)
  }

  useEffect(() => {
    if (time) {
      const interval = setInterval(() => {
        if (time.m == 0 && time.s == 1) {
          console.log("clear interval")
          clearInterval(interval)
          setTimeoutWarning(false)
          setTime(null)
        }
        else if (time.s == 0) {
          setTime(pre => ({ ...pre, m: time.m - 1, s: 59 }))
        } else {
          if (time.m == 0 && time.s == 31) { //show warning on 30sec left
            console.log("show war minutes")
            setTimeoutWarning(true)
          }
          setTime(pre => ({ ...pre, s: time.s - 1 }))
        }
      }, 1000);
      return () => clearInterval(interval)
    }
  }, [time])

  const onOrderBtnHandler = async() => {
    setIsLoading(true)

    const apiResponse = await dispatch(orderNewBTNs(token, box._id, 1));

    if (apiResponse?.number) {
      setOrderedBtn(apiResponse[0]);
      await dispatch(fetchAvailableOobBTNs(token, box?._id));
    } else {
      toast.error(`Something went wrong. Please try again.`);
      setOrderedBtn(null)
      setIsLoading(false);
    }
    setOrderBtn(false);
    onChangeInput('editOption', false);
  }

  return (
    <Modal isOpen={isOpen} style={{ maxWidth: '70%' }}>
      <div  className="band-management-container">
        {state.loading ?
          (
            <SpinnerCircles red />
          ) : (
            bandModelWindow === bandModelWindowsOption.faInput) ? (
              <GetTwoFaModal
                options={options}
                state={state}
                onChangeInput={onChangeInput}
                oobmTtyData={onChangettyDetails}
                onGoHandler={onGoHandler}
                savedProfiles={savedProfiles}
                user={user}
                refreshSavedProfiles={refreshSavedProfiles}
                userDataBand={userDataBand}
              />
          ) : (
            bandModelWindow === bandModelWindowsOption.faAuth) ? (
            TwoFaAuthInput(state, onChangeInput)
          ) : (
            bandModelWindow === bandModelWindowsOption.webSSH) ? (
            <iframe src="http://10.15.43.125:10250/" height={400} width="100%" />
          ) : (
            isTTY &&
            state.twoFaId &&
            state.usb && (
                    <MyTerminal
                      twoFaId={state.twoFaId}
                      usb={state.usb}
                      vpnAddress={box.vpnAddress}
                      onCloseClick={onCancelClick}
                      setIncreaseTerminalLife={setIncreaseTerminalLife}
                      increaseTerminalLife={increaseTerminalLife}
                      setTime={setTime}
                      forceClose={forceClose}
                      did={state?.number}
                      usbTitle={state?.title}
                      usbLabel={state?.label}
                    />
            )
          )
        }

        <div
          className={`management-modal-btn-section mt-2 ${bandModelWindow === bandModelWindowsOption.ttyShell ? 'oobm-modal-footer' : '' }`}
          style={{ justifyContent: bandModelWindow === bandModelWindowsOption.ttyShell ? 'flex-start' : `${(!state.loading && bandModelWindow === bandModelWindowsOption.faInput) ? 'space-between' : 'flex-end'}` }}
        >
          {(!state.loading && bandModelWindow === bandModelWindowsOption.faInput) &&
          (orderBtnOobm === 'write' || orderBtnOobm === 'both') && 
            <Button color="primary"  className={'order-btn'} onClick={() => setOrderBtn(true)}>
              Order BTN
            </Button>
          }
          {
            (bandModelWindow !== bandModelWindowsOption.webSSH && bandModelWindow === bandModelWindowsOption.ttyShell) &&
            <Button outline onClick={(bandModelWindow === bandModelWindowsOption.ttyShell) ? ttyCloseHandler : onCancelClick}>
              Close
            </Button>
          }
          <div>
            {
              (bandModelWindow !== bandModelWindowsOption.webSSH && bandModelWindow !== bandModelWindowsOption.ttyShell) &&
              <Button outline onClick={(bandModelWindow === bandModelWindowsOption.ttyShell) ? ttyCloseHandler : onCancelClick}>
                Close
              </Button>
            }
            {
              (bandModelWindow === bandModelWindowsOption.faAuth) &&
              (
                <Button color="primary" disabled={loading || state.loading} onClick={onGoHandler} className="ml-2">
                  {state.editOption ? 'Save' : 'Connect'}
                </Button>
              )
            }
          </div>
        </div>
      </div>
      <CustomWarning
        isOpen={timeoutWarning}
        onConfirm={() => {
          setTimeoutWarning(false)
          setIncreaseTerminalLife(true)
        }}
        customText="Dismiss"
      >
        Your OOBM session is about to close in  <b>{time?.s} Seconds </b>due to inactivity. Please dismiss this message to continue; otherwise, the session will be closed.
      </CustomWarning>

      {orderBtn && (
        <CustomWarning
          isOpen={orderBtn}
          onConfirm={() => {
            onOrderBtnHandler()
            onChangeInput('editOption', true);
          }}
          customText="Order"
          customCancelText={'No'}
          onCancel={() => {
            setOrderBtn(false);
            setIsLoading(false)
            setOrderedBtn(null)
          }}
          loading={isLoading}
        >
          Are you sure you want to order a new Billing Telephone Number (BTN)? Only order a BTN if a new Out of Band endpoint is being added.
        </CustomWarning>
      )}

      {/* Show OobmEditMode Modal */}
      {isLoading && orderedBtn && (
        <OobmEditMode
          isOpen={isLoading}
          onClose={() => {
            setRefreshSavedProfiles(!refreshSavedProfiles);
            setIsLoading(false)
            onChangeInput('editOption', false);
            setOrderedBtn(null)
          }}
          apiResponse={orderedBtn || {}}  // Pass the response data to OobmEditMode
          dbResponse={orderedBtn}
          box={box}
          mode={'Add'}
        />
      )}
    </Modal>
  );
};

export default React.memo(BandManagementModal);